import React, { useEffect, useRef, useState } from 'react'

import { Button, Grid, Input, InputMask, Line, SelectForm } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import useLoading from 'hooks/useLoading'
import { NovoUsuarioForm } from 'pages/Supplier/Users/components/ModalNewUser/ModalNewUser'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { ProfileUserServices } from 'services/Supplier/Users'
import { COLORS, SPACING } from 'utils'
import { PerfilUsuario, UsuarioFornecedor } from 'utils/types'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './ModalEditUser.styles'

interface IModalEditUser {
  showModal: boolean
  toggleModal: () => void
  onSubmit: any
  userData: UsuarioFornecedor
}
const ModalEditUser: React.FC<IModalEditUser> = ({
  onSubmit,
  showModal,
  toggleModal,
  userData
}) => {
  const { reset, watch, control, handleSubmit, formState } =
    useForm<NovoUsuarioForm>()
  const cpfPass = watch('cdDocto')

  const [listProfiles, setListProfiles] = useState<PerfilUsuario[] | []>([])
  const { setLoading, setMsgErro } = useLoading()
  useEffect(() => {
    const getProfiles = async () => {
      setLoading('loading')
      try {
        const response = await ProfileUserServices().get(null, 'F')
        setListProfiles(response.data)
        setLoading('idle')
      } catch (error) {
        setLoading('error')
        setMsgErro(error.toString())
      }
    }
    getProfiles()
  }, [])

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      showModal={showModal}
      reference={draggableReference}
      onClose={() => {
        toggleModal()
        reset()
      }}
      width={'sm'}
    >
      <Line />
      <FormDialog
        onSubmit={handleSubmit((data) => {
          onSubmit(data)
          resetModalState(draggableReference)
          reset()
        })}
      >
        <DialogTitleStyled>Editar Usuário</DialogTitleStyled>
        <DialogContentStyled>
          <Grid gridCols="1fr 1fr" gridGap="1rem">
            <Input
              label="Colaborador"
              formValue="nmUsuario"
              control={control}
              errors={formState.errors}
              defaultValue={userData?.usuario?.nmUsuario}
              disabled
            />
            <Input
              label="CPF/Passaporte"
              placeholder="XXX.XXX.XXX-XX"
              mask={
                isNaN(parseInt(cpfPass)) ? ['NN##########'] : ['###.###.###-##']
              }
              formValue="cdDocto"
              control={control}
              errors={formState.errors}
              defaultValue={userData?.usuario.cdDocto}
              disabled
            />
          </Grid>
          <Grid gridCols="1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
            <Input
              defaultValue={userData?.usuario?.txEmail}
              label="E-mail"
              formValue="txEmail"
              control={control}
              errors={formState.errors}
              required
              disabled
            />
            <InputMask
              defaultValue={userData?.usuario?.nuContato}
              label="Contato"
              placeholder="(XX) XXXX-XXXX"
              formValue="nuContato"
              masks="cellphone"
              control={control}
              errors={formState.errors}
              required
              disabled
            />
            <SelectForm
              defaultValue={userData?.usuario?.perfilUsuario.idPerfilUsuario}
              control={control}
              formValue="perfilUsuarioId"
              errors={formState.errors}
              required
              listOptions={listProfiles}
              label="Perfil"
              valueMenu="idPerfilUsuario"
              labelMenu="txDenominacao"
            />
          </Grid>
        </DialogContentStyled>

        <DialogActionsStyled>
          <Button
            text="Voltar"
            variantButton="outlined"
            backgroundColor={COLORS.white}
            textColor={COLORS.black}
            marginRight={SPACING.spacing20}
            borderColor={COLORS.black}
            onClick={() => {
              toggleModal()
              resetModalState(draggableReference)
              reset()
            }}
          />
          <Button text="Salvar" type="submit" />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default ModalEditUser
